import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import FeaturesSection from './components/FeaturesSection';
import TeamSection from './components/TeamSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <NavBar />
      <main>
        <HeroSection />
        <ProductsSection />
        <FeaturesSection />
        <TeamSection />
        <ContactSection />
      </main>
    </div>
  );
}
